import { render, staticRenderFns } from "./CoreSkillsSidebarForm.vue?vue&type=template&id=484af301&scoped=true&"
import script from "./CoreSkillsSidebarForm.vue?vue&type=script&lang=js&"
export * from "./CoreSkillsSidebarForm.vue?vue&type=script&lang=js&"
import style0 from "./CoreSkillsSidebarForm.vue?vue&type=style&index=0&id=484af301&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484af301",
  null
  
)

export default component.exports